/*
 * @Description: 自定义指令
 * @Author: 
 * @Date: 2022-07-18 13:51:13
 * @LastEditTime: 2022-07-18 16:31:19
 * @LastEditors: dongqianqian
 * @Usage: 
 */
export default {
  // 限制文本框只能输入整数和浮点数
  inputFloat: {
    bind: function (el) {
      let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
      ele.addEventListener('input', () => {
        let temp = ele.value;
        temp = temp.replace(/[^0-9.]/g, '');
        ele.value = temp;
      }, true);
    }
  },
  // 限制文本框只能输入数字
  inputNumber: {
    bind: function (el) {
      let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
      ele.addEventListener('input', () => {
        let temp = ele.value;
        temp = temp.replace(/\D/g, '');
        ele.value = temp;
      }, true);
    }
  }
}